import classes from './pagination.scss';
import PropTypes from 'prop-types';

const Link = function (props) {

  return (
    <div className={classes.sceOptionBlockPagination}>
      <a role='button' href='javascript:;' className={props.isSelected ? classes.isSelected : ''} onClick={(target) => {props.onClick(target, props.value);
        document.activeElement.blur();
      }} onKeyPress={(target) => props.onKeyPress(target, props.value)} >{props.value}</a>
    </div>
  );

};

const PaginationComponent = function (props) {
  const isMobile = app.appUtil.detectMobile();
  const onKeyPress = (e, value) => {
    var currentPage = props.currentPage;
    var pageFlag=null;
    value > currentPage ? pageFlag = 'nextPage' : pageFlag = 'prevPage';
    props.onPageChange(value);
  };

  const analyticsTracking = (linkName) => {
    let events = {
      alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:false,componentName:null, search:false
  },  pathName = window.location.pathname === '/mysce/usage' ? 'usage' : window.location.pathname === '/mysce/settings' ? 'settings' : 'dashboard';
  app.analyticsService.addPageLevelData('eventCapturing', events);
  setTimeout(()=>{
    window.aUtils ? window.aUtils.sendAAEvent("pagination", `${pathName}|none|none|none|page|${linkName}`) : null;      
  },1500);
  };

  const onClick = (e, value) => {
    var currentPage = props.currentPage;
    var pageFlag=null;
    value > currentPage ? pageFlag = 'nextPage' : pageFlag = 'prevPage';
    props.onPageChange(value,pageFlag);
    let events = {
      alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:false,componentName:null, search:false
  },  pathName = window.location.pathname === '/mysce/usage' ? 'usage' : window.location.pathname === '/mysce/settings' ? 'settings' : 'dashboard';
  app.analyticsService.addPageLevelData('eventCapturing', events);
  analyticsTracking(`${value} of ${props.pageCount}`);  
  };

  const onNext = () => {
    var currentPage = props.currentPage;
    let events = {
      alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:false,componentName:null, search:false
  },  pathName = window.location.pathname === '/mysce/usage' ? 'usage' : window.location.pathname === '/mysce/settings' ? 'settings' : 'dashboard';
  app.analyticsService.addPageLevelData('eventCapturing', events);  
    if (currentPage < props.pageCount) { 
    analyticsTracking(`right arrow`);  
      props.onPageChange(currentPage + 1,'nextPage');
    }
  };

  const onPrevious = () => {
    var currentPage = props.currentPage;
    let events = {
      alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:false,componentName:null, search:false
  },  pathName = window.location.pathname === '/mysce/usage' ? 'usage' : window.location.pathname === '/mysce/settings' ? 'settings' : 'dashboard';
  app.analyticsService.addPageLevelData('eventCapturing', events);  
    if (currentPage > 1) {
      props.onPageChange(currentPage - 1,'prevPage');
    analyticsTracking(`left arrow`);        
    }
  };
  const anchorLink=(i,currentPage)=>{
    return <Link
    onClick={(target, value) => onClick(target, value)}
    onKeyPress={(target, value) => onKeyPress(target, value)}
    value={i}
    isSelected={currentPage === i ? true : false} />;
  };
  const getStartEndPage=( currentPage, pageFlag,siblings)=>{
    let startPage = null, endPage = null;
  
    if (isMobile) {
      startPage = pageFlag === 'prevPage' ? currentPage - siblings : currentPage;
      endPage = pageFlag === 'prevPage' ? currentPage : currentPage + siblings;
    } else {
      startPage = currentPage - siblings;
      endPage = currentPage + siblings;
    }
    return {startPage,endPage};
  };

  const renderPageNumbers = () => {
    const { currentPage, pageCount, pageFlag } = props;
    const numToShow = isMobile ? 3 : 5;
    const siblings = 1;
    const elements = [];
    
    //For first 5 pages
    if(pageCount<=numToShow+1){
      for (let i = 1; i <= pageCount; i++) {
        elements.push(
         anchorLink(i,currentPage));
    }}
    else if (currentPage <= (numToShow-1)) {
      for (let i = 1; i <= Math.min(numToShow, pageCount); i++) {
        elements.push(
          anchorLink(i,currentPage));
      }
      if (pageCount > numToShow) {
        // if(numToShow+1!==pageCount){
        elements.push(<span className={classes.sce_ellipsesBlock} key="right-ellipsis">...</span>);}
        elements.push(<Link
          onClick={(target, value) => onClick(target, value)}
          onKeyPress={(target, value) => onKeyPress(target, value)}
          value={pageCount}
          isSelected={currentPage === pageCount ? true : false} />);
      // }
    }
    //For last 5 pages
    else if (currentPage > pageCount - (numToShow-1)) {
      elements.push(
        <Link
          onClick={(target, value) => onClick(target, value)}
          onKeyPress={(target, value) => onKeyPress(target, value)}
          value={1}
          isSelected={false} />,
        // (numToShow+1!==pageCount)?<span className={classes.sce_ellipsesBlock} key="left-ellipsis">...</span>:null
        <span className={classes.sce_ellipsesBlock} key="left-ellipsis">...</span>
      );
      for (let i = pageCount - numToShow + 1; i <= pageCount; i++) {
        elements.push(
          anchorLink(i,currentPage));
      }
    }
    // For middle pages
    else {
      let {startPage,endPage} = getStartEndPage(currentPage, pageFlag, siblings);
      elements.push(
        <Link
          onClick={(target, value) => onClick(target, value)}
          onKeyPress={(target, value) => onKeyPress(target, value)}
          value={1}
          isSelected={false} />
      );
      if (isMobile)
        startPage !== numToShow-1 && endPage !== numToShow ? elements.push(<span className={classes.sce_ellipsesBlock} key="left-m-ellipsis">...</span>) : null;
      else
        currentPage >= numToShow ? elements.push(<span className={classes.sce_ellipsesBlock} key="left-m-ellipsis">...</span>) : null;
      
      for (let i = startPage; i <= endPage; i++) {
        elements.push(
          anchorLink(i,currentPage));
      }
      if (isMobile)
        startPage !== pageCount-2 && endPage !== pageCount ? elements.push(<span className={classes.sce_ellipsesBlock} key="right-m-ellipsis">...</span>) : null;
      else
        currentPage <= (pageCount+siblings) - numToShow ? elements.push(<span className={classes.sce_ellipsesBlock} key="right-m-ellipsis">...</span>) : null;
      elements.push(
        <Link
          onClick={(target, value) => onClick(target, value)}
          onKeyPress={(target, value) => onKeyPress(target, value)}
          value={pageCount}
          isSelected={false} />
      );
    }
    return elements;
  };

  if (props.pageCount <= 1) {
    return null;
  } else {
    return (
      <div className={classes.PaginationComponent}>
        <div className={classes.sceFlexDisplay}>
            {props.currentPage !== 1 ? <span className={classes.buttonStyle}>
              <a role='button' tabIndex={0} onClick={() => onPrevious()} onKeyPress={() => onPrevious()}>
                <img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_pagi_active.svg'} alt='prevBtn-active' aria-label='Previous button active' className={classes.arrowColorLeft} />
              </a>
            </span> : <span className={classes.buttonStyle}><img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_pagi_inactive.svg'} alt='prevBtn-inactive' aria-label='Previous button inactive' className={classes.arrowColorRight} /></span>}
            <span className={classes.scePaginationBlock}>
              {renderPageNumbers()}
            </span>
            {props.currentPage !== props.pageCount ? <span className={classes.buttonStyle}>
              <a role='button' tabIndex={0} aria-label='next-page' onClick={() => onNext()} onKeyPress={() => onNext()}>
                <img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_pagi_active.svg'} className={classes.arrowColorRight} alt='prevBtn-active' aria-label='Next button active' />
              </a>
            </span> : <span className={classes.buttonStyle}><img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_pagi_inactive.svg'} className={classes.arrowColorLeft} alt='nextBtn-inactive' aria-label='Next button inactive' /></span>}
        </div>
      </div>
    );
  }
};

export default PaginationComponent;


PaginationComponent.propTypes = {
  pageCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

PaginationComponent.defaultProps = {
  pageCount: 0,
  currentPage: 1
};